module Meevo.Components.Controls {
    "use strict";

    export interface ILocationSelectorContext {
        selectedStateChanged(): void;
        reset(): void;
        search(): void;
        changeLocation(location: any): void;
        searchResults: any;
        cityCriteria: any;
        ngModel: angular.INgModelController;
    }

    export class LocationSelectorContext implements ILocationSelectorContext {
        private itemsPerPage: any = 20;
        searchResults: any;
        searchCriteria: any = {};
        cityCriteria: any = {};
        selectedState: any = undefined;
        selectedCity: any = undefined;
        showMobileLocationForm: boolean = true;
        ngModel: angular.INgModelController;

        constructor(private $window: angular.IWindowService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private identityService: Meevo.Components.Common.IIdentityService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private changeLocationOverride: Function = null,
            private excludeCurrentLocation: boolean = false
        ) { }

        selectedStateChanged(): void {
            this.selectedCity = undefined;
            this.cityCriteria = this.selectedState ? { state: this.selectedState.state } : {};
        }

        reset(): void {
            this.searchCriteria = {};
            this.cityCriteria = {};
            this.selectedState = undefined;
            this.selectedCity = undefined;
        }

        search(): void {
            this.searchResults = new Meevo.Components.BaseClasses.PagedResults(this.dataService, "location");

            this.searchCriteria.city = this.selectedCity ? this.selectedCity.city : undefined;
            this.searchCriteria.state = this.selectedState ? this.selectedState.state : undefined;
            this.searchCriteria.filterBySessionUser = true;

            if (this.excludeCurrentLocation) {
                this.searchCriteria.excludeIdList = [this.identityService.locationId];
            }

            // Prepare request
            let request = {
                pageNumber: 1,
                itemsPerPage: this.itemsPerPage,
                criteria: this.searchCriteria,
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false
            };

            // Execute request into ties
            this.searchResults.initSearch(request);
        }

        changeLocation(location: any): void {
            this.ngModel.$setViewValue(location);

            if (_.isFunction(this.changeLocationOverride)) {
                this.changeLocationOverride({ location: location });
            }
        }
    }
}